module.exports = __webpack_public_path__ + "static/media/intro-video-es.02206386.mp4";